import { EditorPropertyWithKey } from '@lg/shared'
import { BusinessObject } from '@lg/shared'
import { BranchNameType, BusinessObjectItem } from '@lg/shared'
import { EditorHelperService } from './editor-helper.service'
import { DevBarService } from '@lg/ng-shared'
import { inject, Injector } from '@angular/core'
import {
	BoSpecificDetails,
	BoSpecificDetailsQuery,
	getBoSpecificDetailsCacheKey,
} from '@lg/shared'
import { BoReference } from '@lg/shared'
import { EditorHelperServiceInjectionToken } from '../../injection-tokens'

export abstract class EditorHelper<
	T extends BusinessObjectItem = BusinessObjectItem,
> {
	// protected devBarService = inject(DevBarService)
	protected boSpecificDetailsCache = new Map<string, BoSpecificDetails>()
	protected helperService = inject(EditorHelperServiceInjectionToken)

	async onPropertyChanged(
		item: T,
		property: EditorPropertyWithKey<BusinessObject, any>,
		allProperties: EditorPropertyWithKey<BusinessObject, any>[],
	): Promise<void> {}
	async modifyEditorProperties(
		item: T,
		properties: EditorPropertyWithKey<BusinessObject, any>[],
		propertyValues: Record<string, any>,
	): Promise<void> {}
	onDoubleClick(branchName: BranchNameType, item: T) {}

	protected async getBoSpecificDetails(
		boRef: BoReference,
		query?: BoSpecificDetailsQuery,
	): Promise<BoSpecificDetails> {
		if (!boRef?.isFullyDefined()) return {}

		const cacheKey = getBoSpecificDetailsCacheKey(boRef, query)
		let details = this.boSpecificDetailsCache.get(cacheKey)
		if (!details) {
			details =
				await this.helperService.trpcService.client.bo.getBoSpecificDetails.query(
					{
						branchName: this.helperService.params.branchName,
						...boRef,
					},
				)
			this.boSpecificDetailsCache.set(cacheKey, details)
		}

		return details
	}

	protected abstract getRefsToReferencedBos(
		item: BusinessObjectItem,
	): Promise<BoReference[]>

	protected async getBoSpecificDetailsForReferencedItems(
		item: BusinessObjectItem,
		query?: BoSpecificDetailsQuery,
	): Promise<BoSpecificDetails[]> {
		const boRefs = await this.getRefsToReferencedBos(item)
		return Promise.all(
			boRefs.map((boRef) => this.getBoSpecificDetails(boRef, query)),
		)
	}
}
